<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.86159 17.3397L8.78328 17.4285C8.44399 17.7677 7.91015 17.7938 7.54093 17.5067L7.45227 17.4285L0.864035 10.8402L0.825068 10.7988L0.773117 10.735L0.705633 10.6303L0.655375 10.5242L0.622059 10.425L0.594858 10.2858L0.588364 10.1747L0.590998 10.1039L0.607376 9.98576L0.635139 9.88089L0.676456 9.77635L0.725775 9.6846L0.795139 9.58602L0.864035 9.50916L7.45227 2.92093C7.8198 2.55338 8.41575 2.55338 8.78328 2.92093C9.12258 3.2602 9.14865 3.79407 8.86159 4.16329L8.78328 4.25195L3.80342 9.2335H18.4707C18.9905 9.2335 19.4119 9.65488 19.4119 10.1747C19.4119 10.6945 18.9905 11.1159 18.4707 11.1159H3.80154L8.78328 16.0974C9.12258 16.4367 9.14865 16.9706 8.86159 17.3397Z"
      class="fill-current"
    />
  </svg>
</template>
